module.exports = __webpack_public_path__ + "static/media/presentation.3e12a71d.svg";